<template>
    <div class="contenedor">
        <b-row>
            <b-col sm="3">
                <b-form-group label="Salud">
                    <el-select v-model="selectedHmis.ambiental"
                               size="small"
                               :disabled="desactivar_edicion"
                    >
                        <el-option v-for="item in opcSalud"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value"
                        />
                    </el-select>
                </b-form-group>
            </b-col>
            <b-col sm="3">
                <b-form-group label="Peligro fisico">
                    <el-select v-model="selectedHmis.fisico"
                               size="small"
                               :disabled="desactivar_edicion"
                    >
                        <el-option v-for="item in opcPelFisico"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value"
                        />
                    </el-select>
                </b-form-group>
            </b-col>
            <b-col sm="3">
                <b-form-group label="Inflamabilidad">
                    <el-select v-model="selectedHmis.inflamabilidad"
                               size="small"
                               :disabled="desactivar_edicion"
                    >
                        <el-option v-for="item in opcInflamabilidad"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value"
                        />
                    </el-select>
                </b-form-group>
            </b-col>
            <b-col sm="3">
                <b-form-group label="Ambiental">
                    <el-select v-model="selectedHmis.ambiental"
                               size="small"
                               :disabled="desactivar_edicion"
                    >
                        <el-option v-for="item in selectedHmis.ambientalHMIS"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value"
                        />
                    </el-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>

            <b-col sm="3">
                <p class="text-center font-weight-bold">
                    Salud
                </p>
                <b-form-group horizontal
                              v-for="(salud,index) in selectedHmis.saludHMIS"
                              :key="'s'+index"
                              :label="salud.label"
                              :disabled="desactivar_edicion"
                >
                    <b-form-radio-group v-model="salud.valor"
                                        :button-variant="salud.valor == 'Si' ? 'outline-primary' : 'outline-secondary'"
                                        buttons
                                        :options="opciones"
                    />
                </b-form-group>
            </b-col>
            <b-col sm="3">
                <p class="text-center font-weight-bold">
                    Peligro físico
                </p>
                <b-form-group horizontal
                              v-for="(peligro,index) in selectedHmis.peligrosHMIS"
                              :key="'p'+index"
                              :label="peligro.label"
                              :disabled="desactivar_edicion"
                >
                    <b-form-radio-group v-model="peligro.valor"
                                        :button-variant="peligro.valor == 'Si' ? 'outline-primary' : 'outline-secondary'"
                                        buttons
                                        :options="opciones"
                    />
                </b-form-group>
            </b-col>
            <b-col sm="3">
                <p class="text-center font-weight-bold">
                    Protección personal
                </p>
                <b-form-group horizontal
                              v-for="(letra,index) in selectedHmis.letrasHMIS"
                              :key="'l'+index"
                              :label="letra.letra"
                              :disabled="desactivar_edicion"
                >
                    <b-form-radio-group v-model="letra.valor"
                                        :button-variant="letra.valor == 'Si' ? 'outline-primary' : 'outline-secondary'"
                                        buttons
                                        :options="opciones"
                    />
                </b-form-group>
            </b-col>
            <b-col sm="3">
                <p class="text-center font-weight-bold">
                    Otros elementos de Protección Personal
                </p>
                <b-form-group horizontal
                              v-for="(otletra,index) in selectedHmis.otrasLetrasHMIS"
                              :key="'ol'+index"
                              :label="otletra.letra"
                              :disabled="desactivar_edicion"
                >
                    <b-form-radio-group v-model="otletra.valor"
                                        :button-variant="otletra.valor == 'Si' ? 'outline-primary' : 'outline-secondary'"
                                        buttons
                                        :options="opciones"
                    />
                </b-form-group>
            </b-col>
        </b-row>

        <b-row v-if="opcionGuardar && validarPermisoComponente('editar-sistemas-clasificacion-productos-nuevo-y-antiguo') && (selectedProduct.producto_bloqueo && !selectedProduct.producto_bloqueo.bloqueo)">
            <b-col class="text-center">
                <hr>
                <b-button size="sm"
                          variant="primary"
                          @click="guardaHmis"
                          v-if="selectedProduct.producto_bloqueo && !selectedProduct.producto_bloqueo.bloqueo"
                >
                    <i class="fa fa-floppy-o"/> Guardar
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {
    mapState,
    mapActions, mapMutations
} from 'vuex';
import { validarPermisoComponente } from '../../../plugins/acl';

export default {
    name: 'Hmis',
    props:{
        desactivar_edicion: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data() {
        return {
            opciones: [
                {text: 'Si', value: 'Si'},
                {text: 'No', value: 'No'},
            ],
            validarPermisoComponente: validarPermisoComponente,
        };
    },
    async mounted() {
        await this.getHmis();
        await this.getOpciones();
        this.opcionesHmis();
    },
    computed: {
        ...mapState('hmis', [
            'selectedHmis',
            'opcSalud',
            'opcInflamabilidad',
            'opcPelFisico',
        ]),
        ...mapState('productos', [
            'opcionGuardar',
            'selectedProduct'
        ])
    },
    methods: {
        ...mapActions('hmis', [
            'getOpciones',
            'getHmis',
            'guardaHmis',
        ]),
        ...mapMutations('hmis', ['opcionesHmis']),
    }
};
</script>
